import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import Header from "./components/header";
import RoutesConfig from "./routes";
import Footer from "./components/footer";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <RoutesConfig />
        <Footer />
      </Router>
    </div>
  );
}

export default App;